module.exports = __webpack_public_path__ + "static/others-b170c4674d4420cbb93013229e7629ab.png";